var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"title is-4 has-text-blue mb-4"},[_vm._v(_vm._s(_vm.feedbackTranslation.companyComments))])]),(_vm.companyInterviewFeedback)?_c('div',[_vm._v(" "+_vm._s(_vm.companyInterviewFeedback)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.feedbackTranslation.noCompanyComments)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }